import React from 'react';
import DigiCert from './components/DigiCert';

export default props => (
  <div className="payment-methods__security-seals">
    <DigiCert {...props} />
  </div>
);
